import { render, staticRenderFns } from "./Popular_topic.vue?vue&type=template&id=389f00f0&"
import script from "./Popular_topic.vue?vue&type=script&lang=js&"
export * from "./Popular_topic.vue?vue&type=script&lang=js&"
import style0 from "./Popular_topic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports